import { Suspense, lazy, useCallback, useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { api } from "@/lib/api";
import Login from "@/pages/Login";
import PublicReport from "@/pages/PublicReport";
import { useTheme } from "@/lib/theme";

const AuthedApp = lazy(() => import("@/AuthedApp"));

const Spinner = () => <div className="flex min-h-screen items-center justify-center"><div className="h-8 w-8 animate-spin rounded-full border-2 border-zinc-700 border-t-amber-500" /></div>;

function App() {
  const pub = window.location.pathname.match(/^\/r\/([\w-]+)/);
  return pub ? <div className="grain min-h-screen"><PublicReport token={pub[1]} /></div> : <MainApp />;
}

function MainApp() {
  const [user, setUser] = useState(null);
  const theme = useTheme();

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    const expired = () => setUser(false);
    window.addEventListener("auth-expired", expired);
    return () => window.removeEventListener("auth-expired", expired);
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } finally { setUser(false); }
  }, []);

  return (
    <div className="grain min-h-screen">
      <Toaster theme={theme} position="bottom-right" richColors />
      {user === null ? <Spinner /> : !user ? <Login onSuccess={setUser} /> : (
        <Suspense fallback={<Spinner />}><AuthedApp user={user} setUser={setUser} onLogout={logout} /></Suspense>
      )}
    </div>
  );
}

export default App;
